import { useNavigate, useParams } from "react-router-dom";
import {
  PushContent,
  MainHeaderWrapper,
  LocationInfoBox,
  AlertContainer,
  PushWarning,
} from "./style/pushSend";
import { useEffect, useState } from "react";
import {
  getAroundCount,
  getPinCount,
  getPushDetail,
  PushRes,
  PushState,
  PushTargetType,
  sendPush,
  sendTemporaryPush,
} from "../../../../api/push";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";
import {
  PageContentHeader,
  PageHeader,
  PageWrapper,
} from "../../../../styles/page";
import PushHistory from "../pushHistory";
import {
  MainWrapper,
  PushContentWrapper,
} from "../pushDetail/style/pushDetail";
import Preview from "../pushPreview";
import { formatDate } from "../../../../utils/date";
import { Overlay } from "../../../../styles/popup";
import { PubOwnerRole, PubOwnerDomain } from "../../../../api/cafe";

const PushMessage = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const pub = useRecoilValue(pubState);

  const prefix = `(${pub?.pubName})`;
  const [pushTitle, setPushTitle] = useState<string>("");
  const [pushText, setPushText] = useState<string>("");
  const [target, setTarget] = useState<PushTargetType>(PushTargetType.PINPOINT);
  const [sendState, setSendState] = useState<PushState>(PushState.SEND);
  const [date, setDate] = useState<string | null>(null);
  const [count, setCount] = useState<number>(0);

  const [historyOpen, setHistoryOpen] = useState<boolean>(false);
  const [selectedPush, setSelectedPush] = useState<PushRes | null>(null);

  const [alertModal, setAlertModal] = useState<boolean>(false);

  const [oneHourCount, setOneHourCount] = useState<number>(0);
  const [twoHoursCount, setTwoHoursCount] = useState<number>(0);

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MARKETING)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const handleHistoryComplete = (item: PushRes) => {
    setSelectedPush(item);
    setPushTitle(item.title);
    setPushText(item.description);
  };

  const getData = async () => {
    if (!id) {
      return;
    }

    const data = await getPushDetail(+id);
    setPushTitle(data.title);
    setPushText(data.description);
    setTarget(data.target);
    setSendState(data.state);
    setDate(data.sendDate);
  };

  const getCount = async () => {
    if (!pub) {
      return;
    }
    try {
      const data = await getPinCount(+pub.id);
      setCount(data);
    } catch (e) {
      setCount(0);
    }
  };

  const getAround = async () => {
    if (!pub) {
      return;
    }

    const data = await getAroundCount(+pub.lat, +pub.lon);
    setOneHourCount(data.withinOneHour);
    setTwoHoursCount(data.withinTwoHours);
  };

  useEffect(() => {
    getData();
    getCount();
    getAround();
  }, []);

  const setSend = (value: string) => {
    if (value === "SEND") {
      setSendState(PushState.SEND);
      setDate(null);
    }

    if (value === "RESERVATION") {
      setSendState(PushState.RESERVATION);
      setDate(formatDate("", true));
    }
  };

  const filterBannedWords = (title: string, text: string) => {
    const bannedWords = [
      "캐시",
      "캐쉬",
      "케시",
      "케쉬",
      "cash",
      "데라",
      "링",
      "데라게임",
      "링게임",
      "타임어택",
      "어택",
      "타임어텍",
      "어텍",
      "천이천",
      "일이오",
      "만포",
      "후속",
      "선데라",
      "레이크",
      "래이크",
      "timeattack",
      "attack",
    ];

    const lowerTitle = title.toLowerCase();
    const lowerText = text.toLowerCase();

    for (let word of bannedWords) {
      if (
        lowerTitle.includes(word.toLowerCase()) ||
        lowerText.includes(word.toLowerCase())
      ) {
        console.log("title :", lowerTitle, ", word :", word);
        console.log("text :", lowerText, ", word :", word);
        setAlertModal(true);

        return false;
      }
    }

    return true;
  };

  const send = () => {
    setSendState(PushState.SEND);
    sendPushMsg();
  };

  const sendPushMsg = async () => {
    if (!pub) return;
    if (!filterBannedWords(pushTitle, pushText)) return;
    const confirm = window.confirm(
      `${pushTitle} \n\n 해당 내용으로 푸시 메시지를 발송하시겠습니까?`,
    );
    if (!confirm) return;

    const request = {
      title: pushTitle,
      description: pushText,
      sendDate: date,
      pubId: pub.id,
      target: target,
      state: sendState,
      data: JSON.stringify({
        goToPage: `/store/${pub.id}?type=PREMIUM`,
        pubLat: pub.lat.toString(),
        pubLon: pub.lon.toString(),
        distance: "5",
      }),
    };

    if (id) {
      const res = await sendTemporaryPush(+id, request);
      alert(res.message);

      return navigate("/push");
    }

    const res = await sendPush(request);
    alert(res.message);

    return navigate("/push");
  };

  const temporary = async () => {
    if (!pub) return;
    if (!filterBannedWords(pushTitle, pushText)) return;

    const request = {
      title: pushTitle,
      description: pushText,
      sendDate: date,
      pubId: pub.id,
      target: target,
      state: PushState.TEMPORARY,
      data: JSON.stringify({
        goToPage: `/store/${pub.id}?type=PREMIUM`,
        pubLat: pub.lat.toString(),
        pubLon: pub.lon.toString(),
        distance: "5",
      }),
    };

    if (id) {
      const res = await sendTemporaryPush(+id, request);
      alert(res.message);

      return navigate("/push");
    }

    const res = await sendPush(request);
    alert(res.message);

    return navigate("/push");
  };

  const [map, setMap] = useState<any>(null);
  useEffect(() => {
    if (!pub) return;
    const mapDiv = document.getElementById("map") as HTMLDivElement;

    if (!mapDiv) return;

    const NaverMaps = window.naver.maps;
    const map = new NaverMaps.Map(mapDiv, {
      center: new NaverMaps.LatLng(pub.lat, pub.lon),
      tileSpare: 3,
      zoom: 11,
      minZoom: 11,
      maxZoom: 11,
    });
    setMap(map);

    new NaverMaps.Marker({
      position: new NaverMaps.LatLng(pub.lat, pub.lon),
      map: map,
      icon: {
        position: new NaverMaps.LatLng(pub.lat, pub.lon),
        content: `
            <div id="marker"/>
          `,
        anchor: new NaverMaps.Point(6, 6),
      },
    });

    new NaverMaps.Circle({
      map: map,
      center: new NaverMaps.LatLng(pub.lat, pub.lon),
      radius: 5000,
      fillColor: "#6436E733",
      fillOpacity: 0.5,
      strokeColor: "#8359F780",
      strokeOpacity: 1,
      strokeWeight: 2,
    });
  }, []);

  return (
    <>
      <PageWrapper>
        <PageHeader>PUSH 메시지</PageHeader>
        <MainWrapper>
          <PageContentHeader>
            <div className="title">PIN PUSH</div>
            <MainHeaderWrapper>
              <div className="sendCount">
                <div>
                  <span className="countTitle">발송 가능 횟수</span>
                  <span>{count}회</span>
                </div>
              </div>
              <div
                className="messageHistory"
                onClick={() => setHistoryOpen(true)}
              >
                이전 메시지 불러오기
              </div>
            </MainHeaderWrapper>
          </PageContentHeader>
          <PushContentWrapper>
            <PushContent>
              <div className="pushContent">
                <div className="pushTitleWrapper">
                  <div>알림 제목</div>
                  <input
                    type="text"
                    value={
                      pushTitle?.startsWith(prefix)
                        ? pushTitle
                        : prefix + (pushTitle || "")
                    }
                    onChange={(e) => {
                      const value = e.target.value;

                      let content = value.startsWith(prefix)
                        ? value.slice(prefix.length)
                        : value;

                      setPushTitle(prefix + content);
                    }}
                    placeholder="제목을 입력해주세요. "
                  />
                </div>
                <div className="pushTitleWrapper">
                  <div>알림 텍스트</div>
                  <textarea
                    value={pushText || ""}
                    onChange={(e) => setPushText(e.target.value)}
                    placeholder="내용을 입력해주세요. "
                  />
                </div>
                <div className="pushTitleWrapper">
                  <div>예약</div>
                  <div>
                    <input
                      type="radio"
                      name="res"
                      onClick={() => {
                        setSend("SEND");
                      }}
                      checked={!date ? true : false}
                    />{" "}
                    <span>지금보내기</span>
                    <input
                      type="radio"
                      name="res"
                      onClick={() => {
                        setSend("RESERVATION");
                      }}
                      checked={date ? true : false}
                    />{" "}
                    <span>예약 보내기</span>
                  </div>
                  {date && (
                    <input
                      type="datetime-local"
                      onChange={(e) =>
                        setDate(formatDate(e.target.value, true))
                      }
                      value={date ? date : ""}
                    />
                  )}
                </div>
                <div className="pinpoint">
                  <LocationInfoBox>
                    <div id="map" />
                  </LocationInfoBox>
                  <div className="pinpointGuide">
                    <div className="title">
                      현재 범위 내 러너러너 이용자 <br />{" "}
                      {oneHourCount >= twoHoursCount
                        ? `${oneHourCount}명 ~ ${twoHoursCount}명`
                        : `${twoHoursCount}명 ~ ${twoHoursCount}명`}
                      <span>
                        실시간 기준이며, IOS 이용 유저 약관 거부 시 데이터에
                        <br />
                        포함 되지 않을 수 있습니다.
                      </span>
                    </div>
                    <div className="guide">
                      <div>핀포인트 범위 안내</div>
                      <span>
                        매장 반경 5KM 이내에
                        <br />
                        최근 앱 활동이 확인되는 기기에 발송됩니다.
                      </span>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <div className="buttonGroup">
                <div onClick={() => temporary()}>임시 저장하기</div>
                <div
                  className="purple"
                  onClick={() =>
                    oneHourCount === 0 || twoHoursCount === 0
                      ? alert(
                          "반경 5km에 러너러너를 사용하는 유저가 없습니다. ",
                        )
                      : send()
                  }
                >
                  메시지 보내기
                </div>
              </div>
            </PushContent>

            <Preview pushTitle={pushTitle} pushText={pushText} />
          </PushContentWrapper>
        </MainWrapper>
        <PushWarning>
          ※러너러너를 통해 푸시메시지를 전송 시, 현행법에 위배되는 내용이
          있을경우, 민형사상의 처벌대상이 될 수 있으며, 이에따른 내용은
          러너러너에서 도움을 드릴 수 없습니다.※
        </PushWarning>
        {historyOpen && (
          <PushHistory
            onClose={() => setHistoryOpen(false)}
            onComplete={handleHistoryComplete}
          />
        )}
        {alertModal && (
          <AlertContainer>
            <span>
              해당 문구는 불법성으로 간주되어 <br /> 발송하실 수 없습니다.
            </span>
            <div className="redButton" onClick={() => setAlertModal(false)}>
              확인
            </div>
          </AlertContainer>
        )}
        {(historyOpen || alertModal) && <Overlay />}
      </PageWrapper>
    </>
  );
};

export default PushMessage;
